import dayjs from 'dayjs';

export const looksLikeDecimalColumn = (key) => {
    if (key === 'RoomsSoldVar') return false;
    if (key === 'LYRoomsSoldVar') return false;
    if (/roomsold/i.test(key)) return false;
    if (/totrooms|transrooms|grprooms|pickuprooms/i.test(key)) return false;

    // ✅ rate / revenue / percentage columns
    return /(occ|adr|rev|par|var)/i.test(key);
};

export const inferColumnDecimals = (rows) => {
    const result = {};
    if (!Array.isArray(rows)) return result;

    rows.forEach(row => {
        Object.entries(row).forEach(([key, value]) => {
            if (typeof value !== 'number') return;

            if (result[key] === 2) return;

            if (!Number.isInteger(value)) {
                result[key] = 2;
            }
            else {
                // 🔑 fallback for decimal-looking columns
                result[key] ??= looksLikeDecimalColumn(key) ? 2 : 0;
            }

        });
    });

    return result;
};

export const formatText = (text, displaySettings) => {
    if (!text || typeof text !== 'string') return text;
    if (displaySettings?.textFormat === 'upper') return text.toUpperCase();
    if (displaySettings?.textFormat === 'lower') return text.toLowerCase();
    return text;
};

export const formatValue = (value, dataKey, isNumeric, displaySettings, columnDecimals = {}) => {
    if (!isNumeric) {
        if (value === null || value === undefined || value === 'N/A') return value || '';
        if (dataKey === 'SaleDate') return dayjs(value).format('MM/DD/YYYY');
        return formatText(value, displaySettings);
    }

    if (value === null || value === undefined) return '';

    const num = Number(value);
    if (isNaN(num)) return value;

    const decimals = columnDecimals[dataKey] ?? (looksLikeDecimalColumn(dataKey) ? 2 : 0);

    if (displaySettings?.excludeZero && num === 0) return '';

    const isNegative = num < 0;
    const abs = Math.abs(num);

    let formatted;

    // ✅ FINAL ZERO BEHAVIOR
    if (abs === 0) {
        if (displaySettings?.withoutCents) {
            formatted = '0';
        } else {
            formatted = decimals > 0 ? abs.toFixed(decimals) : '0';
        }
    }
    else if (displaySettings?.withoutCents && decimals > 0) {
        formatted = Math.trunc(abs).toString();
    }
    else {
        formatted = decimals > 0 ? abs.toFixed(decimals) : abs.toString();
    }

    formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (isNegative) {
        const format = displaySettings?.negativeFormat || 'normal';
        if (format === 'parentheses') return `(${formatted})`;
        if (format === 'trailing') return `${formatted}-`;
        return `-${formatted}`;
    }

    return formatted;
};